import { render, staticRenderFns } from "./OnboardingInventoryPage.vue?vue&type=template&id=ddffd012&scoped=true&"
import script from "./OnboardingInventoryPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingInventoryPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingInventoryPage.vue?vue&type=style&index=0&id=ddffd012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddffd012",
  null
  
)

export default component.exports